import React from 'react';

import { ClusterNodePresenceIcon } from '~src/settings/dataconnect-settings/sections/dataConnectClusterNodes/ClusterNodePresenceIcon';

import { Node } from '../types/Node';
import { getClusterNodeStatus } from './ClusterNodeStates';

export function DataConnectClusterNodesPresenceIcon(node: Node, poolTestId: string) {
  return (
    <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'cluster-node-status-cell' + poolTestId}>
      {renderClusterNodePresenceIcon(node)}
    </span>
  );
}

function renderClusterNodePresenceIcon(node: Node) {
  const clusterNodeStatus = getClusterNodeStatus();

  if (node.nodeStatus !== null) {
    return (<>
      <ClusterNodePresenceIcon status={node.nodeStatus} clusterNodeStatus={ clusterNodeStatus} />
      {clusterNodeStatus[node.nodeStatus].stateLabel}
    </>);
  }

  return null;
}
